import {stage} from '../stage';

type ConfigShape = {
    [key in 'prod' | 'test' | 'dev' | 'ide']: {
        S3: {
            bucket: string;
            region: string;
            isObjectLockEnabled: boolean;
        }
    };
};

/**
 * FNP-1443: the parsed-messages bucket each stage reads message BODIES from.
 *
 * ⚠️ THE BROWSER FETCHES THE BODY, NOT THE API. Amplify Storage downloads the
 * object directly from S3 with the signed-in user's Cognito credentials, so this
 * file — not `flexi-email-api/config/environments.ts` — decides whether a message
 * body renders. Both were pointed at the OLD shared-services buckets; fixing only
 * the API side changed nothing on screen.
 *
 * ⚠️ A WRONG BUCKET HERE FAILS SILENTLY. The metadata comes from DynamoDB and
 * renders perfectly, so the message opens with its sender, subject and timestamp
 * intact and simply no content. There is no error state, no 500, nothing in the
 * console beyond a Storage debug line. It reads as "this message is empty", which
 * is why it survived the EMAIL cutover being declared complete.
 *
 * 🔑 THESE NAMES ARE READ BACK FROM EACH DEPLOYED `flexi-email-ses-infra-<stage>`
 * STACK, NOT DERIVED. CloudFormation truncates the stack name unpredictably when
 * it generates a bucket name: test came out `-tes-` and prod `-pro-`, neither of
 * which you would guess from the dev entry. Re-read them with:
 *
 *   aws cloudformation list-stack-resources \
 *     --stack-name flexi-email-ses-infra-<stage> --profile flexi-email-<stage> \
 *     --query "StackResourceSummaries[?LogicalResourceId=='ParsedMessagesBucketF941D74E'].PhysicalResourceId"
 */
const storage: ConfigShape = {
    prod: {
        S3: {
            bucket: 'flexi-email-ses-infra-pro-parsedmessagesbucketf941-73kjwpvdy5qf',
            region: 'us-west-2',
            isObjectLockEnabled: false //OPTIONAl - Object Lock parameter
        }
    },
    test: {
        S3: {
            bucket: 'flexi-email-ses-infra-tes-parsedmessagesbucketf941-sywrsmobtdd0',
            region: 'us-west-2',
            isObjectLockEnabled: false //OPTIONAl - Object Lock parameter
        }
    },
    dev: {
        S3: {
            bucket: 'flexi-email-ses-infra-dev-parsedmessagesbucketf941-9ycl0ayxjytv',
            region: 'us-west-2',
            isObjectLockEnabled: false //OPTIONAl - Object Lock parameter
        }
    },
    ide: {
        S3: {
            bucket: 'flexi-email-ses-infra-dev-parsedmessagesbucketf941-9ycl0ayxjytv',
            region: 'us-west-2',
            isObjectLockEnabled: false //OPTIONAl - Object Lock parameter
        }
    },
};

export const config = storage[stage];
